import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import { $get } from '@/api/http'

/**
 * 格式化金额（默认保留两位小数）
 * @param num String或Number类型
 * @returns {String}
 */
export const formatDecimal = (num, n = 2) => {
  // 默认返回 0.00
  if (isNaN(num) || +num === 0) num = 0
  return parseFloat(num).toFixed(n)
}

// 去掉对象中value值为空字符串的属性
export const trim = obj => {
  const newObj = {}
  Object.keys(obj).forEach(key => {
    obj[key] === '' || (newObj[key] = obj[key])
  })
  return newObj
}

// 转化为object类型
export const objectToFilters = obj => {
  return Object.keys(obj).map(key => ({
    label: obj[key],
    value: key
  }))
}

// 表头下拉框渲染公共方法
export const renderHeader = (h, { column, $index }, dic = [], tempResult = []) => {
  dic.forEach(obj => {
    tempResult.push(<el-option key={obj.value} label={obj.label} value={obj.value} />)
  })
  return (
    <el-select
      v-model={this.filterParams[column.labelClassName || column.property]}
      on-input={val => {
        this.handleSelectChange(column.labelClassName || column.property, val)
      }}
      placeholder={column.label}
      clearable
      style="display:flex;width:130px;color:#24CAA4"
    >
      {tempResult}
    </el-select>
  )
}

// 换肤加class函数
export const toggleClass = (element, className) => {
  if (!element || !className) return
  element.className = className
}

// 下载文件
export const downloadFile = (url, fileName = '') => {
  let eleLink = document.createElement('a')
  eleLink.download = fileName
  eleLink.style.display = 'none'
  eleLink.href = url
  // 受浏览器安全策略的因素，动态创建的元素必须添加到浏览器后才能实施点击
  document.body.appendChild(eleLink)
  // 触发点击
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}

export const downloadRaw = (data, fileName = '') => {
  if (!data) {
    return
  }
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// 弹窗构造器
export const dialogServiceCtor = component => {
  let Ctor = Vue.extend(component)
  let instance
  let destroy = () => {
    if (instance) {
      document.body.removeChild(instance.$el)
      instance.$destroy()
      instance = null
    }
  }
  return {
    create(options, callback = () => {}) {
      if (!options) {
        options = {}
      } else if (typeof options === 'function') {
        callback = options
        options = {}
      }
      let _owner = this
      if (!instance) {
        instance = new Ctor(Object.assign({ store, router }, options))
        if (_owner && _owner._isVue) {
          let d = _owner.$options.beforeDestroy
          _owner.$options.beforeDestroy = d ? (Array.isArray(d) ? d.concat(destroy) : [d, destroy]) : [destroy]
        }
        instance.$mount()
        document.body.appendChild(instance.$el)
      }
      Vue.nextTick(() => {
        if (options.propsData) {
          Object.keys(options.propsData).forEach(key => {
            instance.$props[key] = options.propsData[key]
          })
        }
        instance.visible = true
        callback(instance)
      })
    },
    destroy
  }
}

// 防抖
export const debounce = (fn, t) => {
  let timer = null
  return function(...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(fn.bind(this, ...args), t)
  }
}

// 获取字典
export const getDict = async dictName => {
  if (!dictName) {
    return []
  }
  let res = await $get('/commons/combobox/findDictsByType', {
    params: dictName
  })
  if (res && res.body) {
    return res.body.data || []
  } else {
    return []
  }
}

// 转换字典
export const transDictToLabel = (value, dict, valueKey = 'name', labelKey = 'value') => {
  if (Array.isArray(dict)) {
    let item = dict.find(d => d[valueKey] === value)
    if (item) {
      return item[labelKey]
    } else {
      return ''
    }
  } else {
    throw new Error('字典错误')
  }
}

// 计算文字宽度
export const calcTextWidth = (text, fontSize) => {
  let span = document.createElement('span')
  span.innerText = text
  span.style.fontSize = fontSize
  span.style.opacity = '0'
  document.body.appendChild(span)
  let width = span.offsetWidth
  document.body.removeChild(span)
  return width
}

export const formatTime = (time, format = 'yyyy-MM-dd HH:mm:ss') => {
  const dateObj = new Date(time);
  const [year, month, date, hours, minutes, seconds] = [dateObj.getFullYear(), dateObj.getMonth() + 1, dateObj.getDate(), dateObj.getHours(), dateObj.getMinutes(), dateObj.getSeconds()];
  Object.entries({
    yyyy: year,
    MM: month >= 10 ? month : `0${month}`,
    dd: date >= 10 ? date : `0${date}`,
    HH: hours >= 10 ? hours : `0${hours}`,
    mm: minutes >= 10 ? minutes : `0${minutes}`,
    ss: seconds >= 10 ? seconds : `0${seconds}`,
  }).forEach(([key, value]) => {
    format = format.replace(key, value);
  })
  Object.entries({
    M: month,
    d: date,
    m: minutes,
    s: seconds,
  }).forEach(([key, value]) => {
    format = format.replace(key, value);
  })
  return format;
}

export const selectFile = ({
  accept,
  type,
} = {
  type: "file",
}) => new Promise((res, rej) => {
  const input = document.createElement('input');
  input.type = type;
  input.accept = accept;
  input.onchange = e => {
    const file = e.target.files[0];
    console.log(file);
    const url = window.URL.createObjectURL(file);
    res({
      url,
      file,
    })
  }
  input.click();
})

export const upload = (url, form) => {
  const formData = new FormData();
  Object.entries(form).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return fetch(url, {
    method: "post",
    body: formData,
    headers: {
      Authorization: localStorage.getItem("Authorization"),
    },
  }).then((res) => res.json());
}